"use client";

import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {presentedFields, type PresentedField} from "@repo/ui/gailgpt/tool-presentation";
import {apiLive} from "@/lib/api";
import {GetScriptV2Url} from "@/utils/scriptVersioning/api";
import type {PhoneScript} from "@/types/campaigns";
import {ReviewFields, type ToolDetailsProps} from "./ToolPresentationDetails";

const pendingNames = new Map<string, Promise<string | undefined>>();
function loadScriptName(id: string) {
   let pending = pendingNames.get(id);
   if (!pending) {
      pending = apiLive<PhoneScript>(GetScriptV2Url(id), undefined, undefined, undefined, true)
         .then(script => script?.name?.trim() || undefined).finally(() => pendingNames.delete(id));
      pendingNames.set(id, pending);
   }
   return pending;
}

function EvalScript({field}: {field: PresentedField & {value: string}}) {
   const [resolved, setResolved] = useState<{id: string; name?: string}>();
   const id = field.value;
   useEffect(() => {
      if (field.entityName || !id) return;
      let active = true;
      void loadScriptName(id).then(name => {if (active) setResolved({id, name});}).catch(() => {});
      return () => {active = false;};
   }, [id, field.entityName]);
   return <ReviewFields fields={[{...field, format: "entity",
      entityName: field.entityName || (resolved?.id === id ? resolved.name : undefined)}]} />;
}

/** Resolve display names without changing the approved evaluation request. */
export default function EvalToolDetails({presentation, parameters}: ToolDetailsProps) {
   const {t} = useTranslation("ask");
   const fields = presentedFields(parameters, presentation.fields).map(field => field.path.at(-1) === "scriptId"
      ? {...field, label: {text: t("toolApproval.call.script")}} : field);
   return <div className="px-5 pb-5 pt-4"><ReviewFields fields={fields} renderField={field =>
      field.path.at(-1) === "scriptId" && typeof field.value === "string"
         ? <EvalScript field={{...field, value: field.value}} /> : undefined} /></div>;
}
